import React, { useState } from 'react';

function TableData({ keyList, dataList }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');

  // Function to open the modal with the selected image
  const openModal = (imageUrl) => {
    setModalImage(imageUrl);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage('');
  };

  return (
    <>
      <tbody>
        {dataList.length > 0 ? (
          dataList.map((dataItem, index) => (
            <tr key={index}>
              {/* Display the row number (index + 1) */}
              <td className="px-3 py-2 whitespace-nowrap text-sm">{index + 1}</td>

              {/* Iterate through the keys and display respective values */}
              {keyList.map((key, i) => (
                <td key={i} className="px-3 py-2 whitespace-nowrap text-sm">
                  {
                    key === 'installationSurveyDate'
                      ? (dataItem[key] ? new Date(dataItem[key]).toISOString().split('T')[0] : 'N/A')
                      : key === 'consentLetter' || key === 'consentWithFarmer' || key === 'landDoc' || key === 'challan' || key === 'aadharFront' || key === 'aadharBack'
                        ? (
                          dataItem[key] ? (
                            <button
                              onClick={() => openModal(dataItem[key])}
                              className="text-blue-500 underline"
                            >
                              Show Image
                            </button>
                          ) : 'N/A'
                        )
                        : (dataItem[key] ? dataItem[key] : 'N/A')
                  }
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={keyList.length + 1} className="text-center py-2">No data available</td>
          </tr>
        )}
      </tbody>
 
      {/* Modal to display image */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg relative">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-3xl font-bold text-gray-700"
            >
              X
            </button>
            <img
              src={modalImage}
              alt="Modal Content"
              className="max-w-[80vw] max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default TableData;

